<script setup lang="ts">
import Item from '@/components/app/shared/flight-sharing/FaqItem'
import { sharingFaq } from '@/data/app'

export default {
  components: { Item },
	data() {
		return {
			sharingFaq,
		}
	},
}
</script>

<template>
	<div
		class="flex flex-col bg-cream-100 overflow-hidden"
		style="border-radius: 16px"
	>
		<div class="pt-12 px-8 pb-14 flex flex-col items-center">
			<h3
				class="text-grey-700 font-header font-semibold leading-tight text-center text-pretty"
				style="font-size: 28px"
			>Frequently Asked Questions</h3>
		</div>
		<div class="flex flex-col">
			<Item
				v-for="(item, index) in sharingFaq"
				:key="item.question"
				:question="item.question"
				:answer="item.answer"
				:initialOpen="index === 0"
				:class="[
					index < sharingFaq.length - 1 && 'border-b'
				]"
				style="border-color: #E7E2D6"
			/>
		</div>
	</div>
</template>
